<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>Set date and time of check-in</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="9">
          <h2 class="ma-3">Please only create a check-in if the client has already booked a check-in.</h2>
          <v-row>
            <v-col cols="12">
              <validation-observer ref="observer" v-slot="{ invalid }">
                <v-form>
                  <v-row>
                    <v-col cols="6">
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider name="Date" rules="required" v-slot="{ errors, valid }">
                            <v-text-field
                              v-model="form.requiredDate"
                              label="Date of assessment"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :error-messages="errors"
                              :success="valid"
                            ></v-text-field>
                          </ValidationProvider>
                        </template>
                        <v-date-picker v-model="form.requiredDate" @input="menu = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="6">
                      <ValidationProvider name="Time" rules="required" v-slot="{ errorsTime, validTime }">
                        <v-menu
                          ref="menu"
                          v-model="menuTime"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          :return-value.sync="form.requiredTime"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="form.requiredTime"
                              label="Time"
                              prepend-icon="mdi-clock-time-four-outline"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :error-messages="errorsTime"
                              :success="validTime"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="menuTime"
                            v-model="form.requiredTime"
                            full-width
                            @click:minute="$refs.menu.save(form.requiredTime)"
                          ></v-time-picker>
                        </v-menu>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-form>
                <v-btn class="float-right" @click="createAssessmentRecord" :disabled="invalid" :loading="saving"
                  >Create new check-in</v-btn
                >
              </validation-observer>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { CREATE_ASSESSMENTS_RECORD_QUERY } from "../../../constants/graphql/assessments/assessment";

export default {
  name: "NewAssessment",
  props: {
    close: {
      type: Function,
      default: null,
    },
    userId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      saving: false,
      menu: false,
      menuTime: false,
      form: {
        requiredDate: null,
        requiredTime: null,
      },
    };
  },
  methods: {
    createAssessmentRecord() {
      this.saving = true;
      let requiredDate = new Date(this.form.requiredDate + " " + this.form.requiredTime);

      this.$apollo
        .mutate({
          mutation: CREATE_ASSESSMENTS_RECORD_QUERY,
          variables: {
            userId: this.userId,
            requiredDate: requiredDate,
          },
          refetchQueries: ["userPrograms", "ClientUserPrograms"],
        })
        .then((result) => {
          if (!result.data.createAssessmentRecord.created) {
            alert(result.data.createAssessmentRecord.error);
          } else {
            this.$toasted.success("Assessment created", {
              icon: "arm-flex",
              duration: 2000,
              position: "bottom-center",
            });
          }
          this.saving = false;
          this.$refs.observer.reset();
        })
        .catch((error) => {
          this.saving = false;
        });
    },
  },
};
</script>
